<template>
  <section class="content">

    <div class="callout callout-info" v-show="!offlineSetting">
      <h4>Device Offline !</h4>
      <p>The parameters of the device could not be set.</p>
    </div>

    <div class="row" v-show="isShowSos">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Duress Alarm Setting</h3>
            <div class="box-tools">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
              <button type="button" v-on:click="toSetDuressAlarmSetting" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'"  data-target="#modal-duress-alarm-setting"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>

          <div class="box-body parameter-setting-box-body">
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Status:&nbsp;&nbsp;</span>{{settingData.alarmsetting.isOpen?'On':'Off'}}</p>
            <p class="parameter-setting-box-body-content" v-show="false">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">SOS Code:&nbsp;&nbsp;</span>7890</p>
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">SOS Message Content:&nbsp;&nbsp;</span>{{settingData.alarmsetting.text?settingData.alarmsetting.text:'(empty)'}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
    <div class="col-xs-12">
      <div class="box box-solid">
        <div class="box-header with-border">
          <h3 class="box-title">Customize Home Arm function</h3>
          <div class="box-tools">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
            </button>
            <button type="button" v-on:click="toSetHomeArmFunction" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-customize-homearm"><i class="fa fa-reorder (alias)"></i></button>
          </div>
        </div>

        <div class="box-body parameter-setting-box-body">
          <p class="parameter-setting-box-body-content">
            <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Active Accessories:&nbsp;&nbsp;</span></p>
          <p class="parameter-setting-box-body-content">
            <span class="cust-homearm-plugin">PIR Sensor:&nbsp;&nbsp;</span>{{this.pirNameList}}</p>
          <p class="parameter-setting-box-body-content">
            <span class="cust-homearm-plugin">Door/Window Sensor:&nbsp;&nbsp;</span>{{this.doorNameList}}</p>

        </div>
      </div>
    </div>
  </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Entry Delay</h3>
            <div class="box-tools">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
              <button type="button" v-on:click="toSetEntryDelay" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-entry-delay"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>

          <div class="box-body parameter-setting-box-body">
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Delay Time:&nbsp;&nbsp;</span>{{this.settingData.entrydelaytime>0?this.settingData.entrydelaytime+'s':'No delay'}}</p>
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Active Accessories:&nbsp;&nbsp;</span></p>
            <p class="parameter-setting-box-body-content">
              <span class="cust-homearm-plugin">PIR Sensor:&nbsp;&nbsp;</span>{{this.entrypirNameList}}</p>
            <p class="parameter-setting-box-body-content">
              <span class="cust-homearm-plugin">Door/Window Sensor:&nbsp;&nbsp;</span>{{this.entrydoorNameList}}</p>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Exit Delay</h3>
            <div class="box-tools">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
              <button type="button" v-on:click="toSetExitDelay" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-exit-delay"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>

          <div class="box-body parameter-setting-box-body">
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Delay Time:&nbsp;&nbsp;</span>{{this.settingData.exitdelaytime>0?this.settingData.exitdelaytime+'s':'No delay'}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Siren Duration</h3>
            <div class="box-tools">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
              <button type="button" v-on:click="toSetSirenDuration" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-siren-duration"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>

          <div class="box-body parameter-setting-box-body">
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Time:&nbsp;&nbsp;</span>{{this.settingData.sirentime>0?this.settingData.sirentime+'min':'Silent'}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="false">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Select Timezone</h3>
            <div class="box-tools">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
              <button type="button" v-on:click="toSetSelectTimezon" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-select-timezone"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>

          <div class="box-body parameter-setting-box-body">
            <p class="parameter-setting-box-body-content">
              <i class="fa fa-circle-o text-yellow parameter-setting-label"></i><span class="parameter-setting-box-body-title">Timezone:&nbsp;&nbsp;</span>{{this.settingData.timezone}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="parameter-setting-advanced-title">Advanced Settings</div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Restart the Device</h3>
            <div class="box-tools">
              <button type="button" v-on:click="toSetRestartDevice" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-restart-device"><i class="fa fa-reorder (alias)"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="row">-->
      <!--<div class="col-xs-12">-->
        <!--<div class="box box-solid">-->
          <!--<div class="box-header with-border">-->
            <!--<h3 class="box-title">Reset the Device</h3>-->
            <!--<div class="box-tools">-->
              <!--<button type="button" v-on:click="toSetResetDevice" :class="offlineSetting?'btn btn-box-tool':'btn btn-box-tool disabled'" data-target="#modal-reset-device"><i class="fa fa-reorder (alias)"></i></button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->


    <!--edit setting dialog-->

    <!--Duress Alarm Setting-->
    <div class="modal fade in" id="modal-duress-alarm-setting">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Duress Alarm Setting</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-xs-3 control-label agent-edit-modal-name">Duress Alarm</label>
                <div class="col-xs-3 modal-parameter-setting-switch">
                  <input type="checkbox" id="alarm_setting_switch" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Password for Duress Alarm</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input id="alarm_setting_password" class="form-control" placeholder="Keep the current password" v-bind:value="settingData.alarmsetting.password">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Custom the SOS message</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <textarea id="alarm_setting_text" class="form-control edit-information-textarea" placeholder="Content sent when duress alarm activated" v-bind:value="settingData.alarmsetting.text"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toSetDuressAlarm">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Duress Alarm Setting-->

    <!--Customize Home Arm function-->
    <div class="modal fade in" id="modal-customize-homearm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Customize Home Arm function</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div>
                <p class="device-setting-modal-plugin-title">The official accessory</p>
                <!--配件列表-->
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-pir"></i>PIR Motion Sensor</label>
                  <div class="form-group" v-if="pirData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-for="(item, index) in pirData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input :id="index+'_pir_home_switch'" type="checkbox" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-door"></i>Door/Window Sensor</label>
                  <div class="form-group" v-if="doorData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-for="(item, index) in doorData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input :id="index+'_door_home_switch'" type="checkbox" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div>
                <p class="device-setting-modal-plugin-title">Third party accessory</p>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-pir"></i>PIR Motion Sensor</label>
                  <div class="form-group" v-if="otherpirData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-else v-for="(item, index) in otherpirData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span v-show="false" class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input :id="index+'_other_pir_home_switch'" type="checkbox" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-door"></i>Door/Window Sensor</label>
                  <div class="form-group" v-if="otherdoorData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-else v-for="(item, index) in otherdoorData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span v-show="false" class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input :id="index+'_other_door_home_switch'" type="checkbox" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toSetHomeAlarm">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Customize Home Arm function-->

    <!--Entry Delay-->
    <div class="modal fade in" id="modal-entry-delay">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Entry Delay</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="firmware-version-update">
                <span class="">Delay Time:</span>
                <select id="entry_delay_time" class="firmware-up-select"  v-bind:value="getDelayTime(settingData.entrydelaytime)">
                  <option>No Delay</option>
                  <option>10s</option>
                  <option>20s</option>
                  <option>30s</option>
                  <option>40s</option>
                  <option>50s</option>
                  <option>60s</option>
                  <option>70s</option>
                  <option>80s</option>
                  <option>90s</option>
                </select>
              </div>
              <!--ss-->
              <div>
                <p class="device-setting-modal-plugin-title">The official accessory</p>
                <!--配件列表-->
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-pir"></i>PIR Motion Sensor</label>
                  <div class="form-group" v-if="pirData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-for="(item, index) in pirData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input :id="index+'_pir_entry_switch'" type="checkbox" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-door"></i>Door/Window Sensor</label>
                  <div class="form-group" v-if="doorData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-for="(item, index) in doorData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input type="checkbox" :id="index+'_door_entry_switch'" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div>
                <p class="device-setting-modal-plugin-title">Third party accessory</p>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-pir"></i>PIR Motion Sensor</label>
                  <div class="form-group" v-if="otherpirData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-else v-for="(item, index) in otherpirData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span v-show="false" class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input type="checkbox" :id="index+'_other_pir_entry_switch'" class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
                <div>
                  <label><i class="fa fa-square device-setting-modal-plugin-type-door"></i>Door/Window Sensor</label>
                  <div class="form-group" v-if="otherdoorData.length <= 0">
                    <p class="col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id">No accessories</p>
                  </div>
                  <div class="form-group" v-else v-for="(item, index) in otherdoorData">
                    <p class="col-xs-10 control-label agent-edit-modal-name">{{item.name}}<span v-show="false" class="device-setting-modal-plugin-id">&nbsp;<span>(&nbsp;</span><span>{{item.id}}</span><span>&nbsp;)</span></span></p>
                    <div class="col-xs-2 modal-parameter-setting-switch">
                      <input type="checkbox" :id="index+'_other_door_entry_switch'"  class="switch-checkbox" checked="checked" data-on-color="info" data-off-color="warning">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toDoSetEntryDelay">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Entry Delay-->

    <!--Exit Delay-->
    <div class="modal fade in" id="modal-exit-delay">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Exit Delay</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="firmware-version-update">
                <span class="">Delay Time:</span>
                <select id="exit_delay_time" class="firmware-up-select" v-bind:value="getDelayTime(settingData.exitdelaytime)">
                  <option>No Delay</option>
                  <option>10s</option>
                  <option>20s</option>
                  <option>30s</option>
                  <option>40s</option>
                  <option>50s</option>
                  <option>60s</option>
                  <option>70s</option>
                  <option>80s</option>
                  <option>90s</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Close">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toDoSetExitDelay">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Exit Delay-->

    <!--Siren Duration-->
    <div class="modal fade in" id="modal-siren-duration">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Siren Duration</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="firmware-version-update">
                <span class="">Ringing Time:</span>
                <select id="siren_time" class="firmware-up-select"  v-bind:value="getSirenTime(settingData.sirentime)" >
                  <option>Silent</option>
                  <option>1min</option>
                  <option>2min</option>
                  <option>3min</option>
                  <option>4min</option>
                  <option>5min</option>
                  <option>10min</option>
                  <option>15min</option>
                  <option>20min</option>
                  <option>25min</option>
                  <option>30min</option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toDoSetSirenTime">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Siren Duration-->

    <!--Select Timezone-->
    <div class="modal fade in" id="modal-select-timezone">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Siren Duration</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="firmware-version-update">
                <span class="">Time Zone:</span>
                <select id="select_timezone" class="device-setting-select" v-bind:value="settingData.timezone" >
                  <option>Europe/London</option>
                  <option>Europe/Lisbon</option>
                  <option>Europe/Madrid</option>
                  <option>Europe/Amsterdam</option>
                  <option>Europe/Helsinki</option>
                  <option>Europe/Mariehamn</option>
                  <option>Europe/Oslo</option>
                  <option>Europe/Copenhagen</option>
                  <option>Europe/Paris</option>
                  <option>Europe/Stockholm</option>
                  <option>Europe/Zurich</option>
                  <option>Europe/Berlin</option>
                  <option>Europe/Busingen</option>
                  <option>Europe/Vienna</option>
                  <option>Europe/Rome</option>
                  <option>Europe/Vatican</option>
                  <option>Europe/Athens</option>
                  <option>Europe/Warsaw</option>
                  <option>Europe/Kiev</option>
                  <option>Europe/Moscow</option>
                  <option>Europe/Prague</option>
                  <option>Europe/Bratislava</option>
                  <option>Europe/Ljubljana</option>
                  <option>Europe/Istanbul</option>
                  <option>Africa/Cairo</option>
                  <option>Africa/Johannesburg</option>
                  <option>Asia/Jerusalem</option>
                  <option>Asia/Riyadh</option>
                  <option>Asia/Dubai</option>
                  <option>Asia/Tehran</option>
                  <option>Asia/Karachi</option>
                  <option>Asia/Kolkata</option>
                  <option>Asia/Bangkok</option>
                  <option>Asia/Shanghai</option>
                  <option>Asia/Kuala_Lumpur</option>
                  <option>Asia/Ho_Chi_Minh</option>
                  <option>Asia/Seoul</option>
                  <option>Asia/Tokyo</option>
                  <option>Australia/Hobart</option>
                  <option>Australia/Sydney</option>
                  <option>Australia/Brisbane</option>
                  <option>Australia/Perth</option>
                  <option>America/New_York</option>
                  <option>America/Monterrey</option>
                  <option>America/Halifax</option>
                  <option>America/Argentina/Cordoba</option>
                  <option>America/Fortaleza</option>
                  <option>America/Sao_Paulo</option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toDoSetTimeZone">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Select Timezone-->

    <!--Restart the Device-->
    <div class="modal fade in" id="modal-restart-device">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Restart the Device</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="firmware-version-update">
                <p>After RESTART, the local data and configure of the device will be updated to the Server. It may take several minutes.</p>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
            <button type="button" class="btn btn-danger"  data-toggle="dropdown">Restart</button>
            <ul class="dropdown-menu pull-right alert-del">
              <li><i class="icon fa fa-warning alert-del-warning"></i>Confirm to Restart ?</li>
              <li>
                <button class="btn btn-default">Cancel</button>
                <button class="btn btn-danger" v-on:click="toRestartDevice">Restart</button>
              </li>
            </ul>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Restart the Device-->

    <!--&lt;!&ndash;Reset the Device&ndash;&gt;-->
    <!--<div class="modal fade in" id="modal-reset-device">-->
      <!--<div class="modal-dialog">-->
        <!--<div class="modal-content">-->
          <!--<div class="modal-header">-->
            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
              <!--<span aria-hidden="true">&times;</span></button>-->
            <!--<h4 class="modal-title">Reset the Device</h4>-->
          <!--</div>-->
          <!--<div class="modal-body">-->
            <!--<form class="form-horizontal">-->
              <!--<div class="firmware-version-update">-->
                <!--<span class="">Reset:</span>-->
                <!--<select class="device-setting-select" id="reset_device">-->
                  <!--<option>Erase all content and settings</option>-->
                  <!--<option>Erase all settings, except the factory connected accessories</option>-->
                <!--</select>-->
              <!--</div>-->
            <!--</form>-->
          <!--</div>-->
          <!--<div class="modal-footer">-->
            <!--<button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>-->
            <!--<button type="button" class="btn btn-danger"  data-toggle="dropdown">Reset</button>-->
            <!--<ul class="dropdown-menu pull-right alert-del">-->
              <!--<li><i class="icon fa fa-warning alert-del-warning"></i>Confirm to Reset ?</li>-->
              <!--<li>-->
                <!--<button class="btn btn-default">Cancel</button>-->
                <!--<button class="btn btn-danger" v-on:click="toDoResetDevice">Reset</button>-->
              <!--</li>-->
            <!--</ul>-->
          <!--</div>-->
        <!--</div>-->
        <!--&lt;!&ndash; /.modal-content &ndash;&gt;-->
      <!--</div>-->
      <!--&lt;!&ndash; /.modal-dialog &ndash;&gt;-->
    <!--</div>-->
    <!--&lt;!&ndash;/ Reset the Device&ndash;&gt;-->

    <!-- / edit setting dialog-->

  </section>
</template>
<script>
  import {servers} from '../../demo'
  import api from '../../api'
  import utils from '../../utils'
  import global from '../Global.vue'
  import config from '../../config'

  export default {
    name: 'ParameterSetting',
    data () {
      return {
        servers,
        settingData: {
          alarmsetting: {
            isOpen: false,
            text: ''
          },
          pirData: [],
          otherpirData: [],
          doorData: [],
          otherdoorData: []
        },
        pirNameList: '',
        doorNameList: '',
        entrypirNameList: '',
        entrydoorNameList: '',
        offlineSetting: false,
        pirData: [],
        otherpirData: [],
        doorData: [],
        otherdoorData: [],
        deviceState: 'Disarm',
        isShowSos: false
      }
    },
    mounted () {
      if (this.$route.query.appid !== '2d2204507cd1399283847ac3fcd7f0c8') {
        this.isShowSos = true
      }
      window.jQuery('.switch-checkbox').bootstrapSwitch()
      if (this.$route.query.online === '1') {
        this.offlineSetting = true
      } else {
        this.offlineSetting = false
      }
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.$route.query.deviceid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.request('post', '/getdevicesetting?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              this.settingData = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
              if (!utils.isHasKey(this.settingData, 'otherpirData')) {
                this.settingData.otherpirData = []
              }
              if (!utils.isHasKey(this.settingData, 'otherdoorData')) {
                this.settingData.otherdoorData = []
              }

              if (!utils.isEmpty(this.settingData.pirData)) {
                for (var j = 0; j < this.settingData.pirData.length; j++) {
                  if (!utils.isEmpty(this.settingData.pirData[j].isHomeArmOn)) {
                    if (this.pirNameList.length === 0) {
                      this.pirNameList = this.settingData.pirData[j].name
                    } else {
                      this.pirNameList = this.pirNameList + ',' + this.settingData.pirData[j].name
                    }
                  }
                  if (!utils.isEmpty(this.settingData.pirData[j].isEntryDelayOn)) {
                    if (this.entrypirNameList.length === 0) {
                      this.entrypirNameList = this.settingData.pirData[j].name
                    } else {
                      this.entrypirNameList = this.entrypirNameList + ',' + this.settingData.pirData[j].name
                    }
                  }
                }
              }

              if (!utils.isEmpty(this.settingData.doorData)) {
                for (var i = 0; i < this.settingData.doorData.length; i++) {
                  if (!utils.isEmpty(this.settingData.doorData[i].isHomeArmOn)) {
                    if (this.doorNameList.length === 0) {
                      this.doorNameList = this.settingData.doorData[i].name
                    } else {
                      this.doorNameList = this.doorNameList + ',' + this.settingData.doorData[i].name
                    }
                  }
                  if (!utils.isEmpty(this.settingData.doorData[i].isEntryDelayOn)) {
                    if (this.entrydoorNameList.length === 0) {
                      this.entrydoorNameList = this.settingData.doorData[i].name
                    } else {
                      this.entrydoorNameList = this.entrydoorNameList + ',' + this.settingData.doorData[i].name
                    }
                  }
                }
              }

              if (!utils.isEmpty(this.settingData.otherpirData)) {
                for (var o = 0; o < this.settingData.otherpirData.length; o++) {
                  if (!utils.isEmpty(this.settingData.otherpirData[o].isHomeArmOn)) {
                    if (this.pirNameList.length === 0) {
                      this.pirNameList = this.settingData.otherpirData[o].name
                    } else {
                      this.pirNameList = this.pirNameList + ',' + this.settingData.otherpirData[o].name
                    }
                  }
                  if (!utils.isEmpty(this.settingData.otherpirData[o].isEntryDelayOn)) {
                    if (this.entrypirNameList.length === 0) {
                      this.entrypirNameList = this.settingData.otherpirData[o].name
                    } else {
                      this.entrypirNameList = this.entrypirNameList + ',' + this.settingData.otherpirData[o].name
                    }
                  }
                }
              }

              if (!utils.isEmpty(this.settingData.otherdoorData)) {
                for (var p = 0; p < this.settingData.otherdoorData.length; p++) {
                  if (!utils.isEmpty(this.settingData.otherdoorData[p].isHomeArmOn)) {
                    if (this.doorNameList.length === 0) {
                      this.doorNameList = this.settingData.otherdoorData[p].name
                    } else {
                      this.doorNameList = this.doorNameList + ',' + this.settingData.otherdoorData[p].name
                    }
                  }
                  if (!utils.isEmpty(this.settingData.otherdoorData[p].isEntryDelayOn)) {
                    if (this.entrydoorNameList.length === 0) {
                      this.entrydoorNameList = this.settingData.otherdoorData[p].name
                    } else {
                      this.entrydoorNameList = this.entrydoorNameList + ',' + this.settingData.otherdoorData[p].name
                    }
                  }
                }
              }
              if (this.settingData.deviceState === 0) {
                this.deviceState = 'Arm'
              } else if (this.settingData.deviceState === 1) {
                this.deviceState = 'Home Arm'
              } else {
                this.deviceState = 'Disarm'
              }

              this.pirData = this.settingData.pirData
              this.otherpirData = this.settingData.otherpirData
              this.doorData = this.settingData.doorData
              this.otherdoorData = this.settingData.otherdoorData
            }
          }
        })
    },
    methods: {
      toSetDuressAlarmSetting () {
        if (!this.offlineSetting) {
          return
        }
        window.jQuery('#modal-duress-alarm-setting').modal('show')
        if (this.settingData.alarmsetting.isOpen) {
          window.jQuery('#alarm_setting_switch').bootstrapSwitch('state', true)
        } else {
          window.jQuery('#alarm_setting_switch').bootstrapSwitch('state', false)
        }
        var tempText = this.settingData.alarmsetting.text
        this.settingData.alarmsetting.text = ''
        this.settingData.alarmsetting.text = tempText
        this.settingData.alarmsetting.password = ''
      },
      toSetHomeArmFunction () {
        if (!this.offlineSetting) {
          return
        }
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-customize-homearm').modal('show')
      },
      toSetEntryDelay () {
        if (!this.offlineSetting) {
          return
        }
        var tempTime = this.settingData.entrydelaytime
        this.settingData.entrydelaytime = -1
        this.settingData.entrydelaytime = tempTime
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-entry-delay').modal('show')
      },
      toSetExitDelay () {
        if (!this.offlineSetting) {
          return
        }
        var tempTime = this.settingData.exitdelaytime
        this.settingData.exitdelaytime = -1
        this.settingData.exitdelaytime = tempTime
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-exit-delay').modal('show')
      },
      toSetSirenDuration () {
        if (!this.offlineSetting) {
          return
        }
        var tempTime = this.settingData.sirentime
        this.settingData.sirentime = -1
        this.settingData.sirentime = tempTime
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-siren-duration').modal('show')
      },
      toSetSelectTimezon () {
        if (!this.offlineSetting) {
          return
        }
        var tempZone = this.settingData.timezone
        this.settingData.timezone = ''
        this.settingData.timezone = tempZone
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-select-timezone').modal('show')
      },
      toSetRestartDevice () {
        if (!this.offlineSetting) {
          return
        }
        window.jQuery('#modal-restart-device').modal('show')
      },
      toSetResetDevice () {
        if (!this.offlineSetting) {
          return
        }
        window.jQuery('.switch-checkbox').bootstrapSwitch()
        this.toInitData()
        window.jQuery('#modal-reset-device').modal('show')
      },
      getDelayTime (time) {
        if (time <= 0) {
          return 'No Delay'
        }
        return time + 's'
      },
      getSirenTime (time) {
        if (time <= 0) {
          return 'Silent'
        }
        return time + 'min'
      },
      toDoResetDevice () {
        var resetAll = window.jQuery('#reset_device').get(0).selectedIndex
        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'RESET_DEVICE',
          retainplugins: resetAll === 1,
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              window.jQuery('#modal-reset-device').modal('hide')
            }
          })
      },
      toDoSetTimeZone () {
        var timezone = window.jQuery('#select_timezone').val()
        if (timezone === this.settingData.timezone) {
          window.jQuery('#modal-select-timezone').modal('hide')
          return
        }
        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_DEVICE_TIMEZONE',
          timezone: parseInt(timezone),
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              this.settingData.exitdelaytime = timezone
              window.jQuery('#modal-select-timezone').modal('hide')
            }
          })
      },
      toDoSetExitDelay () {
        var time = 0
        var times = window.jQuery('#exit_delay_time').val()
        if (times === 'No Delay') {
          time = 0
        } else {
          time = times.replace('s', '')
        }

        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_EXITDELAY',
          time: parseInt(time),
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              this.settingData.exitdelaytime = time
              window.jQuery('#modal-exit-delay').modal('hide')
            }
          })
      },
      toDoSetEntryDelay () {
        var datas = []
        var third = []
        var newask = []
        for (var j = 0; j < this.pirData.length; j++) {
          this.pirData[j].isEntryDelayOn = window.jQuery('#' + j + '_pir_entry_switch').bootstrapSwitch('state')
          if (!this.pirData[j].isAsk) {
            datas.push({id: this.pirData[j].id, entrydelayenable: this.pirData[j].isEntryDelayOn})
          } else {
            newask.push({id: this.pirData[j].id, entrydelayenable: this.pirData[j].isEntryDelayOn})
          }
        }
        for (j = 0; j < this.doorData.length; j++) {
          this.doorData[j].isEntryDelayOn = window.jQuery('#' + j + '_door_entry_switch').bootstrapSwitch('state')
          if (!this.doorData[j].isAsk) {
            datas.push({id: this.doorData[j].id, entrydelayenable: this.doorData[j].isEntryDelayOn})
          } else {
            newask.push({id: this.doorData[j].id, entrydelayenable: this.doorData[j].isEntryDelayOn})
          }
        }
        for (j = 0; j < this.otherpirData.length; j++) {
          this.otherpirData[j].isEntryDelayOn = window.jQuery('#' + j + '_other_pir_entry_switch').bootstrapSwitch('state')
          if (!this.otherpirData[j].isAsk) {
            third.push({id: this.otherpirData[j].id, entrydelayenable: this.otherpirData[j].isEntryDelayOn})
          } else {
            newask.push({id: this.otherpirData[j].id, entrydelayenable: this.otherpirData[j].isEntryDelayOn})
          }
        }
        for (j = 0; j < this.otherdoorData.length; j++) {
          this.otherdoorData[j].isEntryDelayOn = window.jQuery('#' + j + '_other_door_entry_switch').bootstrapSwitch('state')
          if (!this.otherdoorData[j].isAsk) {
            third.push({id: this.otherdoorData[j].id, entrydelayenable: this.otherdoorData[j].isEntryDelayOn})
          } else {
            newask.push({id: this.otherdoorData[j].id, entrydelayenable: this.otherdoorData[j].isEntryDelayOn})
          }
        }
        var time = 0
        var times = window.jQuery('#entry_delay_time').val()
        if (times === 'No Delay') {
          time = 0
        } else {
          time = times.replace('s', '')
        }
//        保存
        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_ENTRYDELAY',
          datas: JSON.stringify(datas),
          thirdpartydatas: JSON.stringify(third),
          newaskdatas: JSON.stringify(newask),
          time: parseInt(time),
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              this.settingData.pirData = this.pirData
              this.settingData.otherpirData = this.otherpirData
              this.settingData.doorData = this.doorData
              this.settingData.otherdoorData = this.otherdoorData
              this.settingData.entrydelaytime = time
//              window.jQuery('#modal-entry-delay').modal('hide')
              window.location.reload()
            }
          })
      },
      toDoSetSirenTime () {
        var time = 0
        var times = window.jQuery('#siren_time').val()
        if (times === 'Silent') {
          time = 0
        } else {
          time = times.replace('min', '')
        }

        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_SIRENTIME',
          time: parseInt(time),
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              this.settingData.sirentime = time
              window.jQuery('#modal-siren-duration').modal('hide')
            }
          })
      },
      toSetHomeAlarm () {
        var datas = []
        var third = []
        var newask = []
        for (var j = 0; j < this.pirData.length; j++) {
          this.pirData[j].isHomeArmOn = window.jQuery('#' + j + '_pir_home_switch').bootstrapSwitch('state')
          if (!this.pirData[j].isAsk) {
            datas.push({id: this.pirData[j].id, homearmenable: this.pirData[j].isHomeArmOn})
          } else {
            newask.push({sendid: this.pirData[j].sid, stype: this.pirData[j].stype, homearmenable: this.pirData[j].isHomeArmOn})
          }
        }
        for (j = 0; j < this.doorData.length; j++) {
          this.doorData[j].isHomeArmOn = window.jQuery('#' + j + '_door_home_switch').bootstrapSwitch('state')
          if (!this.doorData[j].isAsk) {
            datas.push({id: this.doorData[j].id, homearmenable: this.doorData[j].isHomeArmOn})
          } else {
            newask.push({sendid: this.doorData[j].sid, stype: this.doorData[j].stype, homearmenable: this.doorData[j].isHomeArmOn})
          }
        }
        for (j = 0; j < this.otherpirData.length; j++) {
          this.otherpirData[j].isHomeArmOn = window.jQuery('#' + j + '_other_pir_home_switch').bootstrapSwitch('state')
          if (!this.otherpirData[j].isAsk) {
            third.push({id: this.otherpirData[j].id, homearmenable: this.otherpirData[j].isHomeArmOn})
          } else {
            newask.push({sendid: this.otherpirData[j].sid, stype: this.otherpirData[j].stype, homearmenable: this.otherpirData[j].isHomeArmOn})
          }
        }
        for (j = 0; j < this.otherdoorData.length; j++) {
          this.otherdoorData[j].isHomeArmOn = window.jQuery('#' + j + '_other_door_home_switch').bootstrapSwitch('state')
          if (!this.otherdoorData[j].isAsk) {
            third.push({id: this.otherdoorData[j].id, homearmenable: this.otherdoorData[j].isHomeArmOn})
          } else {
            newask.push({sendid: this.otherdoorData[j].sid, stype: this.otherdoorData[j].stype, homearmenable: this.otherdoorData[j].isHomeArmOn})
          }
        }
//        保存
        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_HOMEARM',
          datas: JSON.stringify(datas),
          thirdpartydatas: JSON.stringify(third),
          newaskdatas: JSON.stringify(newask),
          userid: ''
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              this.settingData.pirData = this.pirData
              this.settingData.otherpirData = this.otherpirData
              this.settingData.doorData = this.doorData
              this.settingData.otherdoorData = this.otherdoorData
              window.jQuery('#modal-customize-homearm').modal('hide')
              window.location.reload()
            }
          })
      },
      toInitData () {
        this.pirData = this.settingData.pirData
        this.otherpirData = this.settingData.otherpirData
        this.doorData = this.settingData.doorData
        this.otherdoorData = this.settingData.otherdoorData
        if (!utils.isEmpty(this.pirData)) {
          for (var j = 0; j < this.pirData.length; j++) {
            window.jQuery('#' + j + '_pir_home_switch').bootstrapSwitch('state', this.pirData[j].isHomeArmOn)
            window.jQuery('#' + j + '_pir_entry_switch').bootstrapSwitch('state', this.pirData[j].isEntryDelayOn)
          }
        }
        if (!utils.isEmpty(this.doorData)) {
          for (j = 0; j < this.doorData.length; j++) {
            window.jQuery('#' + j + '_door_home_switch').bootstrapSwitch('state', this.doorData[j].isHomeArmOn)
            window.jQuery('#' + j + '_door_entry_switch').bootstrapSwitch('state', this.doorData[j].isEntryDelayOn)
          }
        }
        if (!utils.isEmpty(this.otherpirData)) {
          for (j = 0; j < this.otherpirData.length; j++) {
            window.jQuery('#' + j + '_other_pir_home_switch').bootstrapSwitch('state', this.otherpirData[j].isHomeArmOn)
            window.jQuery('#' + j + '_other_pir_entry_switch').bootstrapSwitch('state', this.otherpirData[j].isEntryDelayOn)
          }
        }
        if (!utils.isEmpty(this.otherpirData)) {
          for (j = 0; j < this.otherdoorData.length; j++) {
            window.jQuery('#' + j + '_other_door_home_switch').bootstrapSwitch('state', this.otherdoorData[j].isHomeArmOn)
            window.jQuery('#' + j + '_other_door_entry_switch').bootstrapSwitch('state', this.otherdoorData[j].isEntryDelayOn)
          }
        }
      },
      toRestartDevice () {
        var params = new URLSearchParams()
        var jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SYSTEM_REBOOT'
        }
        params.append('json', JSON.stringify(jsons))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              if (data.Result) {
                utils.showMsg('Restart success')
              }
            }
          })
      },
      toSetDuressAlarm () {
//        开关状态变化
        if (window.jQuery('#alarm_setting_switch').bootstrapSwitch('state') !== this.settingData.alarmsetting.isOpen) {
//          请求设置胁迫报警开关
          var params = new URLSearchParams()
          var jsons = {
            messageid: utils.getMessageId(),
            devtoken: this.$route.query.t,
            cmd: 'SET_INTIMIDATIONALARM_ENABLE',
            enable: window.jQuery('#alarm_setting_switch').bootstrapSwitch('state'),
            userid: ''
          }
          params.append('json', JSON.stringify(jsons))
          if (window.localStorage) {
            params.append('token', this.$router.app.$store.state.user.token)
          }
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
            .then(response => {
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
              var data = response.data
              /* Checking if error object was returned from the server */
              if (data.Status !== 1) {
              } else {
                if (data.Result) {
                  this.settingData.alarmsetting.isOpen = !this.settingData.alarmsetting.isOpen
                  window.jQuery('#modal-duress-alarm-setting').modal('hide')
                }
              }
            })
        }

//        胁迫报警密码变化
        if (window.jQuery('#alarm_setting_password').val() !== '') {
//          请求设置胁迫报警开关
          var passwordParams = new URLSearchParams()
          var passwordJsons = {
            messageid: utils.getMessageId(),
            devtoken: this.$route.query.t,
            cmd: 'SET_INTIMIDATIONALARM_PASSWORD',
            password: window.jQuery('#alarm_setting_password').val(),
            userid: ''
          }
          passwordParams.append('json', JSON.stringify(passwordJsons))
          if (window.localStorage) {
            passwordParams.append('token', this.$router.app.$store.state.user.token)
          }
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, passwordParams)
            .then(response => {
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
              var data = response.data
              /* Checking if error object was returned from the server */
              if (data.Status !== 1) {
              } else {
                if (data.Result) {
                  window.jQuery('#alarm_setting_password').val('')
                }
              }
            })
        }
        //        胁迫报警text变化
        if (window.jQuery('#alarm_setting_text').val() !== this.settingData.alarmsetting.text) {
//          请求设置胁迫报警开关
          var textParams = new URLSearchParams()
          var textJsons = {
            messageid: utils.getMessageId(),
            devtoken: this.$route.query.t,
            cmd: 'SET_INTIMIDATIONALARM_PUSH_TXT',
            pushliterary: window.jQuery('#alarm_setting_text').val(),
            userid: ''
          }
          textParams.append('json', JSON.stringify(textJsons))
          if (window.localStorage) {
            textParams.append('token', this.$router.app.$store.state.user.token)
          }
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, textParams)
            .then(response => {
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
              var data = response.data
              /* Checking if error object was returned from the server */
              if (data.Status !== 1) {
              } else {
                if (data.Result) {
                  this.settingData.alarmsetting.text = window.jQuery('#alarm_setting_text').val()
                  window.jQuery('#modal-duress-alarm-setting').modal('hide')
                }
              }
            })
        } else {
          window.jQuery('#modal-duress-alarm-setting').modal('hide')
        }
      }
    }
  }

</script>

<style>
  .bootstrap-switch-info {
    background-color: #00c0ef !important;
  }
</style>



// WEBPACK FOOTER //
// ParameterSetting.vue?6289dc3a